document.addEventListener("DOMContentLoaded", function () {
  // Select all accordion sections
  const accordionSections = document.querySelectorAll('.accordion-section');

  // Loop through each accordion section
  accordionSections.forEach(function (section) {
    // Find the toggle button within this section
    const toggleButton = section.querySelector('a[href="#accordion"]');
    
    // Find all grid items within this section that are not the accordion header
    const gridItems = section.querySelectorAll(".ss-grid__item:not(.ss-grid-span--12)");

    // Add click event listener to the toggle button
    toggleButton.addEventListener("click", function (event) {
      event.preventDefault();

      // Determine if the accordion is currently open by checking for the 'accordion-open' class
      const isCurrentlyOpen = toggleButton.classList.contains("accordion-open");

      // Toggle visibility of grid items within this section only
      gridItems.forEach(function (item) {
        if (isCurrentlyOpen) {
          item.classList.remove("accordion-visible");
          item.classList.add("hidden-accordion-item");
        } else {
          item.classList.remove("hidden-accordion-item");
          item.classList.add("accordion-visible");
        }
      });

      // Toggle class on the accordion header
      if (isCurrentlyOpen) {
        toggleButton.classList.remove("accordion-open");
        toggleButton.classList.add("accordion-closed");
      } else {
        toggleButton.classList.remove("accordion-closed");
        toggleButton.classList.add("accordion-open");
      }
    });
  });
});




/*add classes to paragraph elements*/

function addFadeUpInViewClasses() {
   
    const paragraphs = document.querySelectorAll('p');

    paragraphs.forEach(function(paragraph) {
  
        paragraph.classList.add('fade-in-up', 'in-view');
    });
}

document.addEventListener('DOMContentLoaded', function() {
    addFadeUpInViewClasses();
});


/*---- In View animation ----*/
document.addEventListener("DOMContentLoaded", function () {
    var elements = document.querySelectorAll(".in-view");
    var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add("animate");
            } else {
                entry.target.classList.remove("animate");
            }
           
            
		 
        });
    });
    elements.forEach((element) => {
        observer.observe(element);
    });
});





/*---- secondary navigation animation ----*/
document.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);
  $("a[href='#product-in-use'], a[href='#product-license-info'], a[href='#product-try-it-out']").css("opacity", "0.5");

  const updateScrollTriggers = () => {
    const startPosition = window.innerWidth > 1600 ? "top 60%" : "top 40%";

    let targetTryItOut = $("#product-try-it-out");
    let tlTryItOut = gsap.timeline({
      scrollTrigger: {
        trigger: targetTryItOut,
        start: startPosition,
        end: "bottom bottom",
        markers: false,
        onEnter: () => {
          $("a[href='#product-try-it-out']").css("opacity", "1");
          $("a[href='#product-in-use'], a[href='#product-license-info'], a[href='#']").css("opacity", "0.5");
        },
        onEnterBack: () => {
          $("a[href='#product-try-it-out']").css("opacity", "0.5");
          $("a[href='#']").css("opacity", "1");
          $("a[href='#product-in-use'], a[href='#product-license-info']").css("opacity", "0.5");
        },
        onLeaveBack: () => {
          $("a[href='#product-try-it-out']").css("opacity", "0.5");
        }
      }
    });

    let targetInUse = $("#product-in-use");
    let tlInUse = gsap.timeline({
      scrollTrigger: {
        trigger: targetInUse,
        start: startPosition,
        end: "bottom bottom",
        markers: false,
        onEnter: () => {
          $("a[href='#product-in-use']").css("opacity", "1");
          $("a[href='#product-try-it-out'], a[href='#product-license-info']").css("opacity", "0.5");
        },
        onEnterBack: () => {
          $("a[href='#product-in-use']").css("opacity", "0.5");
          $("a[href='#product-try-it-out']").css("opacity", "1");
          $("a[href='#product-license-info']").css("opacity", "0.5");
        },
        onLeaveBack: () => {
          $("a[href='#product-in-use']").css("opacity", "0.5");
        }
      }
    });

    let targetLicenseInfo = $("#product-license-info");
    let tlLicenseInfo = gsap.timeline({
      scrollTrigger: {
        trigger: targetLicenseInfo,
        start: startPosition,
        end: "bottom bottom",
        markers: false,
        onEnter: () => {
          $("a[href='#product-license-info']").css("opacity", "1");
          $("a[href='#product-try-it-out'], a[href='#product-in-use']").css("opacity", "0.5");
        },
        onEnterBack: () => {
          $("a[href='#product-license-info']").css("opacity", "0.5");
          $("a[href='#product-try-it-out'], a[href='#product-in-use']").css("opacity", "0.5");     
          $("a[href='#product-in-use']").css("opacity", "1");
        }
      }
    });
  };

  // Initial call
  updateScrollTriggers();

  // Recalculate when window is resized
  window.addEventListener('resize', updateScrollTriggers);
});


























